import { UPDATE_EVENT } from "@graphql"
import { useMutation } from "@apollo/client"

const useUpdateEvent = () => {
  const [updateEvent, {data, loading, error}] = useMutation(UPDATE_EVENT)

  return {
    updateEvent,
    data,
    loading,
    error,
  }
}

export default useUpdateEvent